import { clsx } from 'clsx';
import { useTranslation } from 'react-i18next';

import FlightDown from '@assets/FlightDown.svg';
import FlightUp from '@assets/FlightUp.svg';
import Hotel from '@assets/Hotel.svg';
import DateAndTime from '@components/DateAndTime/DateAndTime';
import Icon from '@components/Icon/Icon';
import Image from '@components/Image/Image';
import { EIcons } from '@enums/icons.enum';
import { LocationType, TripStatus } from '@enums/trips.enum';
import type { Trip } from '@store/trips/tripsSlice';

import classes from './TripCard.module.scss';

type Props = {
	from: Trip['from'];
	to: Trip['to'];
	date: Trip['date'];
	status: Trip['status'];
	onClick: () => void;
};

export const TripCard: React.FC<Props> = ({ from, to, date, status, onClick }: React.PropsWithChildren<Props>) => {
	const { t } = useTranslation();

	return (
		<button className={clsx(classes['container'], status === TripStatus.InRoute && classes['InRoute'])} onClick={onClick} type="button">
			<div className={classes['fromToContainer']}>
				<div className={classes['iconContainer']}>
					<div className={classes['innerContainer']}>
						<Image src={from.type === LocationType.Airport ? FlightDown : Hotel} name={t('tripCard.imgAlt')} size={50} />
					</div>
					<div className={classes['arrowContainer']}>
						<Icon name={EIcons.ArrowRight} size={50} color={'var(--text)'} />
					</div>

					<div className={classes['innerContainer']}>
						<Image src={to.type === LocationType.Airport ? FlightUp : Hotel} name={t('tripCard.imgAlt')} size={50} />
					</div>
				</div>
				<div className={classes['textContainer']}>
					<div className={classes['innerContainer']}>
						<p className={classes['from']}>{from.displayName}</p>
					</div>
					<div className={classes['innerContainer']}>
						<p className={classes['to']}>{to.displayName}</p>
					</div>
				</div>
			</div>
			<DateAndTime bold date={date} status={status} />
		</button>
	);
};
